var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex-grow-1 d-flex flex-column",staticStyle:{"max-height":"200px"}},[_c('input',{ref:"colorPicker",attrs:{"type":"color"}})])}
var staticRenderFns = []

export { render, staticRenderFns }